import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const products = [
  {
    name: "Apple",
    logo: "https://cihaz-sat.easycep.com/images/webp/apple_logo.webp",
    productImage:
      "https://cihaz-sat.easycep.com/images/webp/iphone_telefon.webp",
    link: "#",
    alt: "Apple telefon için en uygun fiyat teklifi al ve sat",
  },
  {
    name: "Samsung",
    logo: "https://cihaz-sat.easycep.com/images/webp/samsung-logo.webp",
    productImage:
      "https://cihaz-sat.easycep.com/images/webp/samsung_telefon.webp",
    link: "#",
    alt: "Samsung telefon için en uygun fiyat teklifi al ve sat",
  },
  {
    name: "Xiaomi",
    logo: "https://cihaz-sat.easycep.com/images/webp/xiaomi_logo.webp",
    productImage:
      "https://cihaz-sat.easycep.com/images/webp/xiaomi_telefon.webp",
    link: "#",
    alt: "Xiaomi telefon için en uygun fiyat teklifi al ve sat",
  },
  {
    name: "Huawei",
    logo: "https://cihaz-sat.easycep.com/images/webp/huawei_logo.webp",
    productImage:
      "https://cihaz-sat.easycep.com/images/webp/huawei_telefon.webp",
    link: "#",
    alt: "Huawei telefon için en uygun fiyat teklifi al ve sat",
  },
  {
    name: "Oppo",
    logo: "https://cihaz-sat.easycep.com/images/webp/oppo_logo.webp",
    productImage: "https://cihaz-sat.easycep.com/images/webp/oppo_telefon.webp",
    link: "https://cihaz-sat.easycep.com/kategori/oppo",
    alt: "Oppo telefon için en uygun fiyat teklifi al ve sat",
  },
  {
    name: "Vivo",
    logo: "https://cihaz-sat.easycep.com/images/vivo_logo_rgb.png",
    productImage: "https://cihaz-sat.easycep.com/images/webp/vivo_telefon.webp",
    link: "#",
    alt: "Vivo telefon için en uygun fiyat teklifi al ve sat",
  },
  {
    name: "Tecno",
    logo: "https://cihaz-sat.easycep.com/images/webp/tecno_logo.webp",
    productImage:
      "https://cihaz-sat.easycep.com/images/webp/tecno_telefon.webp",
    link: "#",
    alt: "Tecno telefon için en uygun fiyat teklifi al ve sat",
  },
  {
    name: "Realme",
    logo: "https://cihaz-sat.easycep.com/images/webp/realme_logo.webp",
    productImage:
      "https://cihaz-sat.easycep.com/images/webp/realme_telefon.webp",
    link: "#",
    alt: "Realme telefon için en uygun fiyat teklifi al ve sat",
  },
];

const ProductCard = ({ product, index }) => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.1 });

  return (
    <motion.div
      ref={ref}
      className="col-span-1 mb-4 relative group overflow-hidden"
      initial={{ opacity: 0, y: 50 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.5, delay: index * 0.2 }}
    >
      <div className="bg-gray-100 shadow-md rounded-lg h-full relative group">
        {/* Kartın İçeriği */}
        <div className="flex items-center p-6 relative group-hover:blur-md transition duration-500">
          {/* Sol Kısım: Logo ve İsim */}
          <div className="flex flex-col items-center w-1/2">
            <img src={product.logo} alt={product.alt} className="mb-4 w-16" />
            <p className="text-center text-lg font-medium text-gray-700">
              {product.name}
            </p>
          </div>
          {/* Sağ Kısım: Ürün Görseli */}
          <div className="flex justify-center items-center w-1/2">
            <img
              src={product.productImage}
              alt={product.alt}
              className="w-60 object-contain"
            />
          </div>
        </div>

        {/* Hover ile Görünecek Katman */}
        <div className="absolute inset-0 bg-white/10 bg-opacity-70 backdrop-blur-md flex flex-col justify-center items-center opacity-0 group-hover:opacity-100 transition-all duration-500 pointer-events-none">
          <p className="text-lg font-semibold text-gray-800">{product.name}</p>
          <p className="text-lg text-gray-800 mt-2">
            {product.name} model telefonunu sat
          </p>
        </div>

        {/* Alt Kısım: Hemen Sat Butonu */}
        <button
          className="w-full bg-black text-white text-center py-3 rounded-b-lg z-10 relative transition duration-700 hover:bg-gradient-to-r hover:from-orange-500 hover:via-red-500 hover:to-pink-500"
          onClick={() => (window.location.href = product.link)}
        >
          <span className="text-sm uppercase tracking-wide">Hemen Sat</span>
        </button>
      </div>
    </motion.div>
  );
};

const ProductList = () => {
  return (
    <div className="bg-gray-50">
      <div className="container mx-auto p-4 max-w-7xl bg-gray">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {products.slice(0, 2).map((product, index) => (
            <ProductCard key={product.name} product={product} index={index} />
          ))}
        </div>
      </div>

      <div className="container mx-auto p-4 max-w-7xl">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {products.slice(2).map((product, index) => (
            <ProductCard
              key={product.name}
              product={product}
              index={index + 2}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProductList;
